// lib
import { Injectable } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';

// elvispos
import { BaseService } from 'ngx-elvis-ds';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { SearchDialogCommands } from './search-dialog.page';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { JHIMService } from 'src/app/jhim/jhim.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchDialogService extends BaseService {

  searchTerm: String = '';

  searchDialogOpen: boolean = false;

  searchData: any = {};
  searchHeaders: any[] = [];
  searchResults: any[] = [];

  pageLoader: HTMLIonLoadingElement;

  searchTypes: {
    value: number, descr: string, current?: boolean
  }[] = [
      { value: 0, descr: 'Items', current: true },
      { value: 1, descr: 'Departments' },
      { value: 5, descr: 'Customers' },
      { value: 12, descr: 'Velocity Codes' },
    ];

  get currentSearchType(): string {
    const searchType = this.searchTypes.find(st => st.current);
    if (searchType) {
      return searchType.value.toString();
    } else {
      return '0';
    }
  }

  constructor(
    private sam: SAMService,
    private config: ConfigService,
    private loadingCtrl: LoadingController,
  ) {
    super();
  }

  subscribeListeners() {
    this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (SearchDialogCommands.UPDATE.includes(msg.Command)) {
        this.updateSearchData(msg.parms);
      }
    });
  }

  clean() {
    for (const st of this.searchTypes) {
      st.current = st.value === 0;
    }
    this.searchTerm = '';
    this.searchData = {};
    this.searchHeaders = [];
    this.searchResults = [];
  }

  onSetSearchOpen(value: boolean) {
    if (value === false) {
      this.clean();
    }

    this.searchDialogOpen = value;
  }

  async onSearch(term) {
    if (term && term !== '') {
      this.sam.onSend({
        Command: 'SEARCH_CENTER',
        parms: {
          Datum: term,
          SearchType: this.searchData.Type === 'ALL' ? this.currentSearchType : this.searchData.SearchType,
          TimeStamp: ''
        }
      });
    }

    if (!this.pageLoader && term && term !== '' && term !== 'EMPTY' && this.config.guiSettings.disableAsyncSearch) {
      // this.pageLoader = await this.loadingCtrl.create({
      //   duration: 7500
      // });

      // this.pageLoader.onDidDismiss().then((resp: any) => {
      //   // if (this.search.searchData.SearchOff !== '1') {
      //   //   document.forms['searchDialogForm'].getElementsByTagName('input')[0].focus();
      //   // }
      // });

      // await this.pageLoader.present();

      if (this.searchData.SearchOff !== '1') {
        document.forms['searchDialogForm'].getElementsByTagName('input')[0].blur();
      }
    }
  }

  updateSearchData(searchUpdateData: any, shouldClearResults = true) {

    if (searchUpdateData.Title) {
      this.searchData.Title = searchUpdateData.Title;
    }

    if (searchUpdateData.Label) {
      this.searchData.Label = searchUpdateData.Label;
    }

    if (parseInt(String(searchUpdateData.index), 10) === 0 || searchUpdateData.Columns) {
      this.searchData = { ...this.searchData, ...searchUpdateData };

      if (shouldClearResults) {
        this.searchResults = [];
      }

      if (this.searchData.Columns) {
        this.searchHeaders = [];
        for (let i = 1; i <= this.searchData.Columns; i++) {
          if (this.searchData[`data${i}`]) {
            this.searchHeaders.push(this.searchData[`data${i}`]);
          }
        }
      }
    } else {
      this.searchResults.push(searchUpdateData);
    }

    this.events.next();
  }
}

